// src/components/forms/RequestQuoteForm/RequestQuoteForm.jsx
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Provider } from "./RequestQuoteFormContext";
import Details from "./Details";
import Contact from "./Contact";
import Review from "./Review";
import Done from "./Done";

const detailsInitialState = {
	from: "",
	to: "",
	quantity: "",
	weight: "",
	height: "",
	width: "",
	length1: "",
	description: "",
};

const contactInitialState = {
	full_name: "",
	phone_number: "",
	email_address: "",
};

const renderStep = (step) => {
	switch (step) {
		case 0:
			return <Details />;
		case 1:
			return <Contact />;
		case 2:
			return <Review />;
		case 3:
			return <Done />;
		default:
			return null;
	}
};

const RequestQuoteForm = (props) => {
	const { onHide } = props;
	const [details, setDetails] = useState(detailsInitialState);
	const [contact, setContact] = useState(contactInitialState);
	const [currentStep, setCurrentStep] = useState(0);
	const [quoteId, setQuoteId] = useState(null);

	const next = () => {
		if (currentStep === 3) {
			setCurrentStep(0);
			setDetails(detailsInitialState);
			setContact(contactInitialState);
			setQuoteId(null);
			onHide();
		}
		setCurrentStep(currentStep + 1);
	};

	const prev = () => setCurrentStep(currentStep - 1);

	useEffect(() => {
		ReactGA.event({
			category: "Quote Form",
			action: "quote_form_opened",
		});
	}, []);

	return (
		<Provider
			value={{
				details,
				setDetails,
				next,
				prev,
				contact,
				setContact,
				quoteId,
				setQuoteId,
			}}
		>
			<main>{renderStep(currentStep)}</main>
		</Provider>
	);
};

export default RequestQuoteForm;
